<template>
	<jdialog
		title="在售价默认加润设置"
		:visible.sync="dialogVisible"
		:isComponent="true"
		@handleCancel="dialogVisible = false"
		width="560px"
	>
		<el-form
			label-width="120px"
			class="form"
			:rules="rule"
			:model="form"
			ref="form"
		>
			<p style="color:red;">
				商品在售价=供应链成本价*（1+加润百分比）+固定加润值
			</p>
			<p style="color:red;">商品在售价加润值不能低于商品供货价加润值</p>

			<el-form-item label="加润百分比：" prop="sale_add_profit_percent">
				<el-input
					placeholder="请输入百分比数值"
					v-model="form.sale_add_profit_percent"
					:min="0"
					:max="100"
					type="number"
				>
					<template slot="append">%</template>
				</el-input>
			</el-form-item>
			<el-form-item label="固定加润值：" prop="sale_add_profit_value">
				<el-input
					placeholder="请输入固定数值"
					v-model="form.sale_add_profit_value"
					:min="0"
					type="number"
				>
					<template slot="append">元</template>
				</el-input>
			</el-form-item>

			<div class="btns">
				<el-button :loading="loading" type="primary" @click="onConfirmClick"
					>确 定</el-button
				>
				<el-button @click="dialogVisible = false">取 消</el-button>
			</div>
		</el-form>
	</jdialog>
</template>

<script>
import { getOnSalePrice, setOnSalePrice } from '../../api/goods'
export default {
	props: {
		// 是否显示
		visible: {
			default: false
		}
	},
	data() {
		return {
			dialogVisible: false,
			loading: false,
			prData: {
				sale_add_profit_percent: 0,
				sale_add_profit_value: 0
			},
			form: {
				sale_add_profit_percent: 0,
				sale_add_profit_value: 0
			},
			rule: {
				sale_add_profit_percent: [
					{ required: true, message: '请输入百分比数值', trigger: 'blur' }
				],
				sale_add_profit_value: [
					{ required: true, message: '请输入固定数值', trigger: 'blur' }
				]
			}
		}
	},
	watch: {
		dialogVisible(newV) {
			this.$emit('update:visible', newV)
		},
		visible(newV) {
			this.dialogVisible = newV
			this.form.sale_add_profit_percent = this.prData.sale_add_profit_percent
			this.form.sale_add_profit_value = this.prData.sale_add_profit_value
		}
	},
	created() {
		//获取设置
		getOnSalePrice().then(res => {
			this.prData = res
			this.form.sale_add_profit_percent = res.sale_add_profit_percent
			this.form.sale_add_profit_value = res.sale_add_profit_value
		})
	},
	methods: {
		onConfirmClick() {
			this.$refs.form.validate(valid => {
				if (valid) {
					this.loading = true
					const data = Object.assign({}, this.form)
					setOnSalePrice(data)
						.then(() => {
							this.prData = data
							this.loading = false
							this.$message.success('修改保存成功！')
						})
						.catch(() => {
							this.loading = false
						})
				} else {
					return false
				}
			})
		}
	}
}
</script>
<style lang="scss" scoped>
.form {
	padding: 10px;
	.btns {
		text-align: right;
		padding-top: 10px;
	}
}
</style>
